<template>
  <div class="recommended">
    <div class="recommended-icon">
      <img :src="icon" :alt="title">
    </div>
    <div class="recommended-content">
      <div class="recommended-title flex-v-center">
        {{ title }}
        <span class="recommended-domain">{{domain}}</span>
      </div>
      <p>{{desc}}</p>
    </div>
    <div class="recommended-controls flex-v-center">
      <a :href="url" target="_blank" class="btn btn-secondary">{{$lang.messages.sites.preview}}</a>
      <button class="btn btn-add" @click="addToLinks()">{{$lang.messages.sites.add_to_list}}</button>
    </div>
    <button class="btn-icon" @click="removeRecommendedLink(id)"><i class="icon-close-small"></i></button>
  </div>
</template>

<script>
import {reportEvent} from "@/helpers/utils";

const images = require.context('../assets/', false, /\.svg$/)
export default {
  name: 'RecommendedLink',
  props: ['icon', 'title', 'domain', 'desc', 'url', 'id'],
  data: function () {
    return {
      menuOpen: false
    }
  },
  methods: {
    imgUrl: function (path) {
      return images('./' + path)
    },
    addToLinks (link) {
      this.$emit('addtolinks', link);
      reportEvent('recommendedLinkAdded')
    },
    removeRecommendedLink (link) {
      this.$emit('removerecommendedlink', link);
    }
  }
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.recommended {
  display: flex;
  background: #EFF1FF;
  border-radius: 15px;
  position: relative;
  padding: 15px 80px 15px 35px;
  margin-bottom: 24px;

  &.-small {
    padding: 10px 15px;
    margin-bottom: 5px;
    margin-top: 5px;

    .recommended-title {
      margin-bottom: 0;

      @include responsive-below($xs){
        padding-left: 0;
        word-break: break-word;
      }
    }
  }

  @include responsive-below($lg){
    padding: 15px 60px 15px 15px;
  }

  @include responsive-below($md){
    flex-wrap: wrap;
  }

  &-icon {
    min-width: 32px;
    max-width: 32px;
    margin-right: 20px;
    text-align: center;

    @include responsive-below($lg){
      min-width: 32px;
      max-width: 32px;
    }

    @include responsive-below($xs){
      position: absolute;
    }
  }

  &-title {
    font-weight: 800;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 6px;
    color: #9485EF;

    @include responsive-below($lg){
      flex-wrap: wrap;
    }

    @include responsive-below($xs){
      padding-left: 50px;
    }
  }

  &-domain {
    color: #828282;
    font-size: 12px;
    margin-left: 16px;
    font-weight: 400;

    @include responsive-below($lg){
      width: 100%;
      margin-left: 0;
    }
  }

  &-content {
    padding-right: 100px;

    @include responsive-below($lg){
      padding-right: 30px;
    }

    @include responsive-below($md){
      padding-right: 0;
    }
  }

  &-controls {
    padding-top: 20px;
    margin-left: auto;

    @include responsive-below($lg){
      flex-direction: column;

      .btn {
        width: 100%;
        margin-bottom: 10px;
        text-align: center;
      }
    }

    @include responsive-below($md){
      flex-direction: row;
    }

    .btn + .btn {
      margin-left: 9px;

      @include responsive-below($lg){
        margin-left: 0;
      }

      @include responsive-below($md){
        margin-left: 9px;
      }
    }
  }

  .btn-icon {
    position: absolute;
    right: 16px;
    top: 16px;
  }
}
</style>
